<!--
 * @Auther: 罗耀祖
 * @Date: 2021-07-08 19:38:16
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-05-30 15:27:17
 * @name: 添加或编辑人员
 * @Description: 添加或编辑人员
 * @FilePath: \preSaleNafterSaleBackstage\src\components\mailList\dialog\addNedit-people.vue
 * @Author: DESKTOP-1QU67QM
-->
<template>
  <addNeditDialog
    ref="addNeditDialog"
    :title="title"
    bar-title="基本信息"
    @close="close"
  >
    <template v-slot:form>
      <div class="line">
        <font class="label"><i class="warn">*</i>姓名:</font>
        <el-input
          class="input"
          v-model="realname"
          placeholder="请输入姓名"
        ></el-input>
      </div>
      <div class="line">
        <font class="label"><i class="warn">*</i>手机号:</font>
        <el-input
          class="input"
          v-model="mobile"
          placeholder="请输入手机号"
          maxlength="11"
        ></el-input>
      </div>
      <div class="line">
        <font class="label"><i class="warn">*</i>所属部门:</font>
        <el-select
          class="input"
          v-model="department_id"
          placeholder="请选择所属部门"
        >
          <el-option
            v-for="item of parents"
            :key="item.id"
            :label="item.department_name"
            :value="item.id"
          ></el-option>
        </el-select>
      </div>
      <div class="line">
        <font class="label"><i class="warn">*</i>职位:</font>
        <el-select class="input" v-model="role_id" placeholder="请选择职位">
          <el-option
            v-for="(value, key) in roles"
            :key="key"
            :label="value"
            :value="key"
          ></el-option>
        </el-select>
      </div>
    </template>
    <template v-slot:btnGroup>
      <el-button type="primary" @click="save">保存</el-button>
      <el-button type="danger" v-if="id" @click="leave">离职</el-button>
      <el-button plain @click="cancel">取消</el-button>
    </template>
  </addNeditDialog>
</template>
<script>
import { confirmation,debounceation } from "@/utils/decorator";
import addNeditDialog from "./addNeditDialog";
export default {
  name: "mailList-Content-addNeditPeople",
  components: {
    addNeditDialog,
  },
  props: {
    mailList: {
      type: Object,
    },
  },
  data() {
    return {
      id: "", //人员id
      realname: "", //人员姓名
      mobile: "", //人员手机号
      department_id: "", //人员所在部门id
      parents: [], //部门列表
      roles: {}, //职位类数组对象
      role_id: "", //选中的职位id
    };
  },
  computed: {
    title() {
      return this.id ? "编辑人员" : "添加人员";
    },
    // 验证姓名是否已填
    realname_match() {
      return this.realname === "";
    },
    // 验证手机号是否已填
    mobile_match() {
      return this.mobile.length != 11;
    },
  },
  methods: {
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 打开dialog
     */
    open(row) {
      let { all, me } = this.mailList.getAllNodeNnow(); //获取所有部门及当前部门
      this.parents = all.filter((x) => x.level > 1);
      this.getRoleList(); //获取职位列表
      // 存在id即为编辑，否则为新增
      if (row?.id) {
        this.id = row.id;
        this.realname = row.realname;
        this.mobile = row.mobile;
        this.department_id = row.department_id;
        this.role_id = String(row.role_id);
      } else {
        this.id = '';
        this.department_id = me;
      }
      this.$refs.addNeditDialog.open();
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 获取职位列表
     */
    getRoleList() {
      this.mailList
        .getRoleList()
        .then((res) => {
          this.roles = res.data;
        })
        .catch(() => {});
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 点击保存
     */
    @debounceation(300)
    save() {
      if (this.id) {
        this.edit();
      } else {
        this.add();
      }
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 人员添加提交
     */
    @confirmation("确认添加?")
    add() {
      this.mailList
        .addPeople({
          realname: this.realname,
          mobile: this.mobile,
          department_id: this.department_id,
          role_id: this.role_id,
        })
        .then((res) => {
          this.cancel();
          this.$emit("updateHandler"); //添加成功, 父组件更新数据
        });
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 人员编辑提交
     */
    @confirmation('确认修改?')
    edit() {
      this.mailList
        .editPeople({
          id: this.id,
          realname: this.realname,
          mobile: this.mobile,
          department_id: this.department_id,
          role_id: this.role_id,
        })
        .then((res) => {
          this.cancel();
          this.$emit("updateHandler"); //修改成功, 父组件更新数据
        });
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 点击离职
     */
    @confirmation('确认离职?')
    leave() {
      this.mailList.delPeople({
        user_ids: [this.id],
      }).then(res => {
        this.$message.success('离职成功!');
        this.cancel();
        this.$emit("updateHandler"); //修改成功, 父组件更新数据
      })
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 点击取消
     */
    @debounceation(300)
    cancel() {
      this.$refs.addNeditDialog.close();
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 初始化
     */
    close() {
      this.id = '';
      this.realname = "";
      this.mobile = "";
      this.department_id = "";
      this.parents = [];
      this.role_id = "";
      this.roles = [];
    },
  },
};
</script>
<style lang="scss" scoped>
.line {
  margin-bottom: 20px;
  width: 400px;
  height: $Var-height-mormal;
  @extend .extend-flex-start;
  .label {
    font-size: $Vars-font-miniTitle-size;
    color: $Vars-font-normal-color;
    width: 100px;
    text-align: left;
    flex-shrink: 0;
    position: relative;
    .warn {
      position: absolute;
      left: -10px;
      content: "*";
      color: red;
    }
  }
  .input {
    flex: 1;
  }
}
.el-button {
  margin-left: 40px;
  width: $Var-button-width-normal;
  &:first-child {
    margin-left: 0;
  }
}
</style>
